import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=73ff2a24&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=73ff2a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff2a24",
  null
  
)

export default component.exports